import React, { useEffect, useState } from 'react';
import { Form, Card, Input, message } from 'antd';
import axios from '../../config/axiosInstance';
import RegasusMobileList from './RegasusMobileList';
import LeadCaptureCard from './LeadCaptureCard';
import SelfcheckinList from './SelfcheckinList';
import RegasusList from './RegasusList';
import { useAuth } from '../../context/AuthContext';

const AppList = () => {
    const [brand, setBrand] = useState(null);
    const { hasFeature, isAdmin } = useAuth?.() || { hasFeature: () => false, isAdmin: false };

    useEffect(() => {
        const fetchBrand = async () => {
            try {
                // Use user-safe endpoint (clientID comes from token on backend)
                const response = await axios.get('/clients/brand');
                console.log('Fetched brand:', response.data);
                setBrand(response.data);
            } catch (error) {
                console.error('Error fetching brand:', error);
                message.error('Could not load brand data.');
            }
        };

        fetchBrand();
    }, []);

    return (
        <div style={{ padding: '24px' }}>
            {brand?.devicePin && (
                <Card title="Customer PIN" style={{ marginBottom: 24, width: 300 }}>
                    <Form layout="vertical">
                        <Form.Item>
                            <Input.OTP
                                value={brand.devicePin}
                                length={6}
                                readOnly
                                variant="filled"
                                style={{
                                    pointerEvents: 'none',
                                    opacity: 1,
                                    cursor: 'default',
                                }}
                            />
                        </Form.Item>
                    </Form>
                </Card>
            )}

            <div
                style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: '24px',
                    marginBottom: '60px',
                }}
            >
                {hasFeature('deviceConfig.mobile') && <RegasusMobileList />}
                {hasFeature('deviceConfig.leadcapture') && <LeadCaptureCard />}
                {hasFeature('deviceConfig.desktop') && <SelfcheckinList />}
            </div>

            <div>
                <RegasusList />
            </div>
        </div>
    );
};

export default AppList;